goog.provide("shadow.js.shim.module$src$svg$artwork$warning_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$warning_svg");
shadow.js.shim.module$src$svg$artwork$warning_svg = shadow.js.nativeProvides["src/svg/artwork/warning.svg"] = shadow$bridge("src/svg/artwork/warning.svg");
module$shadow_js_shim_module$src$svg$artwork$warning_svg.default = shadow.js.shim.module$src$svg$artwork$warning_svg;
